import React from 'react';
import { Row, Col } from 'antd';

interface ActionCardProps {
  text: string; 
  span?: number;
  onClick?: () => void; 
  children?: React.ReactNode; // Allow children for custom content
}

const ActionCard: React.FC<ActionCardProps> = ({ text, span = 6, onClick, children }) => {
  return (
    <Row 
      align="middle" 
      gutter={8} 
      onClick={onClick} 
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <Col span={span}>
        <div className="IconWrapper" style={{ fontSize: '16px' }}> {/* Optional styling */}
          {children}
        </div>
      </Col>
      <Col span={24 - span}>
        <span>{text}</span>
      </Col>
    </Row>
  );
};

export default ActionCard;
